import { render, staticRenderFns } from "./bs4.vue?vue&type=template&id=626b7ae1&scoped=true&"
import script from "./bs4.vue?vue&type=script&lang=js&"
export * from "./bs4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b7ae1",
  null
  
)

export default component.exports